import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'md',
    border: '1px',
    borderColor: 'alpha.200',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    overflow: 'hidden',
  },
  bodyStack: {
    bg: '#EEF8FF',
    p: 2,
    color: 'gray.700',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    fontFamily: 'roboto',
    fontSize: 'sm',
    color: 'gray.700',
  },
  footerFlex: {
    as: 'footer',
    bg: 'alpha.600',
    boxShadow:
      '0px -2px 0px 0px rgba(0, 0, 0, 0.15), 0px -1px 0px 0px rgba(255, 255, 255, 0.25)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    justify: 'space-between',
    px: '2',
    py: '1',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'white',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '1.5',
  },
  footerSportNameIconSvg: {
    color: 'white',
    fontSize: 'sm',
  },
  footerCompetitionNameText: {
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    pt: '0',

    sx: {
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
  },
  footerMatchLinkIcon: {
    color: 'white',
    fontSize: 'sm',
  },
};
